import React from "react";
import Container from '@mui/material/Container';
import BlogContainer from "../components/BlogContainer";


export const Blog = () =>
    <Container>
        <BlogContainer/>
    </Container>

